module.exports = __webpack_public_path__ + "img/t2.9bac8aa5.jpg";